export default __webpack_public_path__ + "static/media/Ballroll_00094.03f6b3e8.png";